import React from 'react';
import { Input, DatePicker, Text } from 'components/tt-forms/common';
import {Link} from 'react-router';
import moment from 'moment';
import { ShowIf } from 'components/utils';

class LanNopTien extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state={
      index: this.props.index,
      id: this.props.theoDoiLanNopTienId ? this.props.theoDoiLanNopTienId : '',
      ngayNopTien: this.props.ngayNopTien ? new Date(this.props.ngayNopTien) : '',
      soTien: this.props.soTien ? this.props.soTien : '',
      tongCong: this.props.tongCong ? this.props.tongCong : '',
      conPhaiThu: this.props.conPhaiThu ? this.props.conPhaiThu : ''
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps != this.props) {
      this.setState({
        index: nextProps.index,
        id: nextProps.theoDoiLanNopTienId ? nextProps.theoDoiLanNopTienId : '',
        ngayNopTien: nextProps.ngayNopTien ? new Date(nextProps.ngayNopTien) : '',
        soTien: nextProps.soTien ? nextProps.soTien : '',
        tongCong: nextProps.tongCong ? nextProps.tongCong : '',
        conPhaiThu: nextProps.conPhaiThu ? nextProps.conPhaiThu : ''
      })
    }
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    }, () => {
      let data ={
        ngayNopTien: this.state.ngayNopTien ? moment(this.state.ngayNopTien).toISOString() : null,
        soTien: this.state.soTien ? this.state.soTien : '',
        tongCong: this.state.tongCong ? this.state.tongCong : '',
        conPhaiThu: this.state.conPhaiThu ? this.state.conPhaiThu : ''
      }
      if (this.state.id) {
        data.id = this.state.id
      }
      this.props.onChange(data, this.state.index - 1)
    })
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      }, () => {
        let data ={
          ngayNopTien: this.state.ngayNopTien ? moment(this.state.ngayNopTien).toISOString() : null,
          soTien: this.state.soTien ? this.state.soTien : '',
          tongCong: this.state.tongCong ? this.state.tongCong : '',
          conPhaiThu: this.state.conPhaiThu ? this.state.conPhaiThu : ''
        }
        if (this.state.id) {
          data.id = this.state.id
        }
        this.props.onChange(data, this.state.index - 1)
      });
    } else {
      this.setState({
        [name]: e
      }, () => {
        let data ={
          ngayNopTien: this.state.ngayNopTien ? moment(this.state.ngayNopTien).toISOString() : null,
          soTien: this.state.soTien ? this.state.soTien : '',
          tongCong: this.state.tongCong ? this.state.tongCong : '',
          conPhaiThu: this.state.conPhaiThu ? this.state.conPhaiThu : ''
        }
        if (this.state.id) {
          data.id = this.state.id
        }
        this.props.onChange(data, this.state.index - 1)
      });
    }
  }

  onRemove() {
    this.props.onRemove(this.state.index - 1)
  }

  render() {
    return (
      <div className='col-100 block-gray p15 mb15'>
        <div className='justify-content mb15'>
          <h2 className='txt-bold txt-upper txt-12'>{`Lần nộp số ${this.state.index}`}</h2>
          <ShowIf condition={this.props.view != true}>
            <Link className='itt-delete' onClick={this.onRemove.bind(this)}>Xóa</Link>
          </ShowIf>
        </div>
        <ShowIf condition={this.props.view != true}>
          <div className='row pl10 pr10'>
            <DatePicker className='col-25 mb0-18' label='Ngày nộp tiền' value={this.state.ngayNopTien} onChange={this.handleChangeDate.bind(this, 'ngayNopTien')} name='ngayNopTien'/>
            <Input type='sdt' align='right' className='col-25 mb0-18' label='Số tiền (đ)' value={this.state.soTien} onChange={this.onChange.bind(this, 'soTien')} name='soTien'/>
            <Input type='sdt' align='right' className='col-25 mb0-18' label='Tổng cộng (đ)' value={this.state.tongCong} onChange={this.onChange.bind(this, 'tongCong')} name='tongCong'/>
            <Input type='sdt' align='right' className='col-25 mb0-18' label='Còn phải thu (đ)' value={this.state.conPhaiThu} onChange={this.onChange.bind(this, 'conPhaiThu')} name='conPhaiThu'/>
          </div>
        </ShowIf>
        <ShowIf condition={this.props.view === true}>
          <div className='row pl10 pr10'>
            <Text className='col-25' label='Ngày nộp tiền:' value={this.props.ngayNopTien ? moment(this.props.ngayNopTien).format('DD/MM/YYYY') : ''}/>
            <Text className='col-25' label='Số tiền (đ):' value={this.props.soTien ? this.props.soTien : ''}/>
            <Text className='col-25' label='Tổng cộng (đ):' value={this.props.tongCong ? this.props.tongCong : ''}/>
            <Text className='col-25' label='Còn phải thu (đ):' value={this.props.conPhaiThu ? this.props.conPhaiThu : ''}/>
          </div>
        </ShowIf>
      </div>
    )
  }
}

export default LanNopTien;



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/LanNopTien.jsx